/** @jsx jsx */

import { jsx } from 'theme-ui'

import Select from 'react-select'

const CustomDropdown = ({ children, options, ...props }) => {
  return (
    <Select
      options={options}
      isClearable
      theme={theme => ({
        ...theme,
        borderRadius: 4,
        colors: {
          ...theme.colors,
          primary25: 'lightGray',
          primary50: 'lightGray',
          primary: 'black',
          primary75: 'gray',
        },
      })}
      {...props}
    />
  )
}

export default CustomDropdown
